import actionTypes from '../constants/action-types';

const numberOfAiGeneratedBlocks = (state = null, action) => {
  if (action.type !== actionTypes.SET_NUMBER_OF_AI_GENERATED_BLOCKS) return state;
  return action.payload.count;
};

export default numberOfAiGeneratedBlocks;
